import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Component, ElementRef, Injector, Input, Type } from "@angular/core";
import { trigger, state, animate, transition, style } from "@angular/animations";
import { BfxTradeContextMenuService } from "./services/bfx-trade-contextmenu.service";
import { BfxBaseBlotterContextMenu } from "../bfx-base-blotter/bfx-base-blotter-contextmenu";

const LINE_HEIGHT: number = 30;
import { LoggerService } from "@bfx/logger";
import { TradeDealPrimaryLookupService } from "shared/cubiq-services";
import { BfxTradeDetailsContextMenuService } from "./services/bfx-trade-blotter-details-contextmenu.service";

const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-trade-context-menu",
  //templateUrl: '../bfx-base-blotter/bfx-base-blotter-contextmenu.html',
  templateUrl: "./html/bfx-trade-contextmenu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  standalone: false,
})
export class BfxTradeContextMenuComponent extends BfxBaseBlotterContextMenu<CubiqTS.DealImpl> {
  @Input("orderDetails") orderDetails: boolean = false;

  constructor(
    injector: Injector,
    lookupService: TradeDealPrimaryLookupService,
    elementRef: ElementRef,
  ) {
    super(injector, lookupService, elementRef);
  }

  protected initialize(): void {
    if (this.orderDetails) {
      this.menuService = this.injector.get(BfxTradeDetailsContextMenuService);

      if (this.showMenuSubscription) {
        this.showMenuSubscription.unsubscribe();
      }

      this.showMenuSubscription = this.menuService.showMenuSubject.subscribe(
        this.handleShowHideEvent.bind(this),
      );
    }

    super.initialize();
  }

  protected getMenuServiceType(): Type<BfxTradeContextMenuService> {
    return BfxTradeContextMenuService;
  }
}
